var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('MomoNav', [_c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_profile.png")
    }
  })])]), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoMemberIndex'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_home.png")
    }
  })])], 1)]), _c('div', {
    staticClass: "huggies-verify"
  }, [_c('div', {
    staticClass: "form position-relative"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field-label mb-3"
  }, [_vm._v("會員姓名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "請輸入真實姓名"
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_vm._m(0), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.mobile,
      expression: "form.mobile"
    }],
    staticStyle: {
      "flex": "1 1 auto",
      "width": "1%"
    },
    attrs: {
      "type": "tel",
      "placeholder": "請輸入手機號碼"
    },
    domProps: {
      "value": _vm.form.mobile
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "input-group-append pl-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "disabled": !_vm.needVerify,
      "type": "button"
    },
    on: {
      "click": _vm.showVerifyDialog
    }
  }, [_vm._v("手機驗證")])])])]), _c('div', {
    staticClass: "field"
  }, [_vm._m(1), _c('div', {
    staticClass: "d-flex city-selector-set-has-value mb-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.county,
      expression: "form.county"
    }],
    staticClass: "county w-50",
    attrs: {
      "data-value": _vm.form.county
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "county", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.form.district = '';
      }]
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.district,
      expression: "form.district"
    }],
    staticClass: "district ml-2 w-50",
    attrs: {
      "data-value": _vm.form.district
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "district", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }), _c('input', {
    staticClass: "zipcode",
    attrs: {
      "id": "zipcode",
      "type": "hidden"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.address,
      expression: "form.address"
    }],
    attrs: {
      "type": "text",
      "placeholder": "請輸入收取禮品地址"
    },
    domProps: {
      "value": _vm.form.address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "address", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field-label mb-3"
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "請輸入Email"
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "button-update text-center mt-5"
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_update.png")
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  })])]), _c('b-modal', {
    ref: "confirm",
    attrs: {
      "title": "請進行手機簡訊驗證",
      "ok-title": "驗證",
      "ok-variant": "outline-primary",
      "ok-disabled": !_vm.canSendVerifyCode,
      "cancel-title": "取消",
      "cancel-variant": "outline-secondary",
      "modal-class": "huggies-verify"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.handleNext.apply(null, arguments);
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "sep"
  }), _c('div', {
    staticClass: "wrap-content"
  }, [_c('h6', [_vm._v(" 請輸入發送至您手機的驗證碼 ")]), _c('div', {
    staticClass: "mb-3",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verifyCode,
      expression: "verifyCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "code",
      "name": "code",
      "placeholder": "請輸入驗證碼",
      "pattern": "[0-9]{6}",
      "disabled": _vm.formLoading
    },
    domProps: {
      "value": _vm.verifyCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value;
      }
    }
  })]), _c('div', {
    attrs: {
      "id": "countdown"
    }
  }, [_c('span', {
    attrs: {
      "id": "sec"
    }
  }, [_vm._v(_vm._s(_vm.seconds))]), _c('span', [_vm._v(" 秒後才可重新發送驗證碼")]), _vm.canResend ? _c('h6', {
    staticStyle: {
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    attrs: {
      "id": "resend"
    },
    on: {
      "click": _vm.sendSmsVerificationCode
    }
  }, [_vm._v(" 重新發送驗證碼 ")]) : _vm._e()])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "field-label"
  }, [_vm._v("聯絡電話")]), _c('small', [_vm._v("若手機號碼重新輸入，會員表單裡電話資料會同步修改 ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "field-label mb-1"
  }, [_vm._v("收取禮品地址")]), _c('small', {
    staticClass: "d-block"
  }, [_vm._v("請填妥：郵遞區號/縣市/鄉鎮市區/路 巷 弄 號 /樓 室 ")]), _c('small', {
    staticClass: "d-block"
  }, [_vm._v("【若資料不完整或地址無法辨識，將無法完成寄件】")])]);
}]

export { render, staticRenderFns }